import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { v4 as uuidv4 } from 'uuid';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { SuppInvPaymentMethodComponent } from '../supp-inv-payment-method/supp-inv-payment-method.component';
import { ReturnTypeComponent } from '../return-type/return-type.component';
import { element } from 'protractor';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-return-invoice',
  templateUrl: './return-invoice.component.html',
  styleUrls: ['./return-invoice.component.css']
})
export class ReturnInvoiceComponent implements OnInit {

  public menu_item_id = '21';
  public add_auth;

  inv_model = {
    'table_name': 'invoice', 'invoice_id': '0', 'invoice_no': '', 'invoice_date': '0000-00-00', 'customer_no': '',
    'customer_name': '', 'calc_tax': '1', 'print_tax': '1', 'total': '', 'tax': '', 'discount': '', 'rep_emp_no': '0',
    'deliver_date': '0000-00-00', 'payment_date': '0000-00-00', 'invoice_type': 'stock', 'cond_list_id': '0',
    'transport_fee': '0', 'received_by': '', 'is_paid': '', 'status': '1', 'cost_center': '0', 'trans_acct': '0',
    'payment_method': ''
  };

  model = {
    'table_name': 'return_invoice', 'return_invoice_id': '0', 'return_invoice_no': '0', 'no': '0', 
    'year': '0', 'invoice_no': '', 'return_date': '', 'customer_no': '', 'customer_name': '', 'total': '', 
    'discount': '', 'tax': '', 'tax_acct': '0', 'ret_sales_acct': '0', 'payment_method': '', 
    'acct_number': '', 'is_paid': '0', 'flag': 'new', 'key': 'return_invoice_id', 'status': '1', 
    'comment': '', 'cost_center': '0', 'branch_id': '0', 'store_id': '0', 'invoice_uuid': ''
  };

  data_model = {
    'final_total': '', 'paid_amount': '', 'rem_amount': '', 'is_paid': '', 'return_date': new Date(),
    'final_total_ret': '', 'bank_acct_number': '0', 'mode': ''
  };
  // , 'has_customer':'0'
  // searchDialogRef: MatDialogRef<SearchCustomerComponent>;
  payDialogRef: MatDialogRef<SuppInvPaymentMethodComponent>;

  public dp = [];
  private dp1 = [];
  displayedColumns1 = ['payment_type_name', 'amount'];
  typeDialogRef: MatDialogRef<ReturnTypeComponent>;
  dataSource1 = new MatTableDataSource(this.dp1);
  @ViewChild(MatSort) sort: MatSort;

  payment_list;

  // for update 

  no = "";
  mode = "";
  // type = '';
  invoice_detail = {};
  inv_payment_method = [];
  count = 0;
  invoice_item = [];
  all_payment_types = [];
  print_type;
  bankAcctList = [];
  bankDetail = '';

  @HostListener('window:keydown', ['$event'])
  handleKeyDownEvent(event: KeyboardEvent) {
    if (event.key == "F7")
      this.saveInvoice('print');

    if (event.key == "F8")
      this.saveInvoice('save_only');
  }
  // @HostListener('document:keydown.F7', ['$event'])
  // handleKeyboardEvent(event: KeyboardEvent) {
  //   this.saveInvoice();
  // }

  Acct_Placeholder; Success_Msg; Error_Msg; No_Inv_Msg; Paid; Unpaid;
  Ret_No_Msg; Main; One_Item_Msg; Bank_Acct_Msg; Pay_Msg; Not_Counter_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, private route: ActivatedRoute, private router: Router,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Acct_Placeholder').subscribe((res: string) => {
      this.Acct_Placeholder = res;
    });
    // this.search_Bank['placeholder'] = this.Acct_Placeholder;

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('No_Inv_Msg').subscribe((res: string) => {
      this.No_Inv_Msg = res;
    });

    translate.get('Paid').subscribe((res: string) => {
      this.Paid = res;
    });

    translate.get('Unpaid').subscribe((res: string) => {
      this.Unpaid = res;
    });

    translate.get('Ret_No_Msg').subscribe((res: string) => {
      this.Ret_No_Msg = res;
    });

    translate.get('Main').subscribe((res: string) => {
      this.Main = res;
    });

    translate.get('One_Item_Msg').subscribe((res: string) => {
      this.One_Item_Msg = res;
    });

    translate.get('Bank_Acct_Msg').subscribe((res: string) => {
      this.Bank_Acct_Msg = res;
    });

    translate.get('Pay_Msg').subscribe((res: string) => {
      this.Pay_Msg = res;
    });

    translate.get('Not_Counter_Msg').subscribe((res: string) => {
      this.Not_Counter_Msg = res;
    });
  }

  ngOnInit() {
    let obj;

    // get leaf bank accts
    let parent_acct = this.applicationConstants.main_acct_config['bank'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.bankAcctList = data.data['list'];
      });

    this.route.params.subscribe(params => {
      // console.log(params['no']);
      if (params['no'] != undefined) {
        // this.type = 'invoice';
        this.no = params['no'];
        if (this.no.indexOf('RET') != -1) {
          this.mode = 'edit';
          this.data_model['mode'] = 'edit';
        }
        else
          (document.getElementById('invoice_no') as HTMLInputElement).value = this.no;
        this.getInvInfo();
      }
    });

    if (this.no == '') {
      // check add authorization
      this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);

      this.typeDialogRef = this.dialog.open(ReturnTypeComponent, {
        hasBackdrop: false,
        //data: this.dialog_data
      });
      this.typeDialogRef
        .afterClosed()
        .subscribe(result => {
          //console.log(this.acct_income);
        });
    }
    else
      this.add_auth = true;

    let query;

    // ******************* Get All Payment Types to send array to inv_payment_method component ******************* //
    query = this.queryList.all_paymentType;
    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.all_payment_types = data.data['list'];
        if (this.all_payment_types.length == 5)
          this.all_payment_types.splice(4, 1);

      });

    // END 

    this.print_type = this.utils.getParamValue('print_type');
    let default_payment_type = this.utils.getParamValue('default_payment_type');
    if (default_payment_type != undefined || default_payment_type != '') {
      query = "SELECT * FROM `payment_type` WHERE `status` = '1' AND `payment_type_key` = '" +
        default_payment_type + "'";
      obj = { cmd: 'getList', query: query };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          this.payment_list = data.data['list'];
        });
    }

    // query = "SELECT * FROM `param` WHERE `status` = '1' AND `name` = 'default_payment_type'";
    // obj = { cmd: 'getList', query: query };
    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     let default_payment_type = data.data['list']['0']['value'];

    //     if (default_payment_type != undefined || default_payment_type != '') {
    //       let query = "SELECT * FROM `payment_type` WHERE `status` = '1' AND `payment_type_key` = '" + default_payment_type + "'";
    //       let obj = { cmd: 'getList', query: query };
    //       this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //         .subscribe(data => {
    //           this.applicationConstants.appComp.hideBusyCursor();
    //           this.payment_list = data.data['list'];
    //         });
    //     }
    //   });

    // query = this.queryList.all_bank;
    // obj = { cmd: 'getList', query: query };
    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     this.bankList = data.data['list'];

    //     selObj = {
    //       'account_id': '0', 'bank_acct_number': '', 'acct_number': '0', 'account_name': 'اختر',
    //       'account_name_en': 'Select'
    //     };
    //     this.bankList.unshift(selObj);
    //   });

  }


  getInvInfo() {
    let query;

    if (this.mode == 'edit') {
      //query = "SELECT * FROM `return_invoice` WHERE `return_invoice_no` = '" + this.no + "' AND `status` != '0'";
      query = "SELECT `return_invoice`.`return_invoice_id`, `return_invoice`.`branch_id`, " +
        "`return_invoice`.`return_invoice_no`, `return_invoice`.`return_date`, " +
        "`return_invoice`.`invoice_no`, `return_invoice`.`total` as 'ret_total', " +
        "`return_invoice`.`discount` as 'ret_discount', `return_invoice`.`tax` as 'ret_tax', " +
        "`return_invoice`.`comment` as 'ret_comment', `invoice`.* FROM " +
        "`return_invoice`, `invoice` WHERE `return_invoice`.`return_invoice_no` = '" +
        this.no + "' AND `return_invoice`.`invoice_no` = `invoice`.`invoice_no`";
    }
    else {
      let inv_no = (document.getElementById('invoice_no') as HTMLInputElement).value;
      query = "SELECT * FROM `invoice` WHERE `invoice_no` = '" + inv_no + "' AND `status` != '0'";
    }

    let obj = { cmd: 'getList', query: query };
    console.log(query);
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        console.log(data.data['list']);
        if (data.data['list'].length == 0) {
          alert(this.No_Inv_Msg);
          return;
        }

        this.invoice_detail = data.data['list'][0];
        console.log(this.invoice_detail);
        // if (this.mode == 'edit') {

        // }
        //this.model['invoice_date'] = this.invoice_detail['invoice_date'];
        this.inv_model['invoice_id'] = this.invoice_detail['invoice_id'];
        this.inv_model['invoice_no'] = this.invoice_detail['invoice_no'];
        (document.getElementById('invoice_no') as HTMLInputElement).value = this.invoice_detail['invoice_no'];
        this.inv_model['invoiceDate'] = new Date(this.invoice_detail['invoice_date']);
        this.inv_model['has_customer'] = (this.invoice_detail['customer_no'] == '' ? '0' : '1');
        this.inv_model['customer_no'] = this.invoice_detail['customer_no'];
        this.inv_model['customer_name'] = this.invoice_detail['customer_name'];

        if (this.invoice_detail['customer_no'] == '')
          (document.getElementById('customer_name') as HTMLInputElement).value = this.inv_model['customer_name'];
        else {
          query = "SELECT * FROM `customer` WHERE `acct_number` = '" + this.invoice_detail['customer_no'] + "'";
          obj = { cmd: 'getList', query: query };

          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              let custDetail = data.data['list'][0];
              (document.getElementById('customer_name') as HTMLInputElement).value = custDetail['customer_no'] +
                "-" + custDetail['customer_name'] + "-" + custDetail['customer_name_en'] + "-" +
                custDetail['mobile'];
              // this.customer_name = data.data['list'][0]['customer_name'];
              // this.mobile = data.data['list'][0]['mobile'];
            });
        }
        //if (this.mode != 'edit') {
        if (this.invoice_detail['cost_center'] == '0')
          (document.getElementById('cost_center') as HTMLInputElement).value = this.Main;
        else {
          query = "SELECT `cc_name` FROM `cost_center` WHERE `cc_number` = '" + this.invoice_detail['cost_center'] + "'";
          obj = { cmd: 'getList', query: query };

          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();

              let ccDetail = data.data['list'][0];
              (document.getElementById('cost_center') as HTMLInputElement).value = ccDetail['cc_name'];
            });
        }
        //}
        //this.model['comment'] = this.invoice_detail['comment'];
        this.inv_model['total'] = this.invoice_detail['total'];
        this.inv_model['discount'] = this.invoice_detail['discount'];
        this.inv_model['tax'] = this.invoice_detail['tax'];
        this.data_model['final_total'] = (Number(this.invoice_detail['total']) -
          Number(this.invoice_detail['discount']) + Number(this.invoice_detail['tax'])).toFixed(2);

        if (this.mode == 'edit') {
          this.data_model['final_total_ret'] = (Number(this.invoice_detail['ret_total']) -
            Number(this.invoice_detail['ret_discount']) + Number(this.invoice_detail['ret_tax'])).toFixed(2);

          this.model['return_invoice_id'] = this.invoice_detail['return_invoice_id'];
          this.model['return_invoice_no'] = this.invoice_detail['return_invoice_no'];
          this.model['no'] = this.invoice_detail['no'];
          this.model['year'] = this.invoice_detail['year'];
          this.model['total'] = this.invoice_detail['ret_total'];
          this.model['tax'] = this.invoice_detail['ret_tax'];
          this.model['discount'] = this.invoice_detail['ret_discount'];
          this.model['return_date'] = this.invoice_detail['return_date'];
          this.data_model['return_date'] = new Date(this.invoice_detail['return_date']);
          this.model['is_paid'] = this.invoice_detail['is_paid'];
          this.model['comment'] = this.invoice_detail['ret_comment'];
          this.model['flag'] = 'update';

          // this.model['ret_sales_acct'] = this.invoice_detail['ret_sales_acct'];
          // this.model['payment_method'] = this.invoice_detail['payment_method'];
          // this.model['acct_number'] = this.invoice_detail['acct_number'];
        }

        this.model['customer_no'] = this.invoice_detail['customer_no'];
        this.model['customer_name'] = this.invoice_detail['customer_name'];
        this.model['cost_center'] = this.invoice_detail['cost_center'];
        this.model['branch_id'] = this.invoice_detail['branch_id'];
        this.model['store_id'] = this.invoice_detail['store_id'];

        this.inv_model['rep_emp_no'] = this.invoice_detail['rep_emp_no'];
        this.inv_model['deliver_date'] = this.invoice_detail['deliver_date'];
        this.inv_model['payment_date'] = this.invoice_detail['payment_date'];
        this.inv_model['cond_list_id'] = this.invoice_detail['cond_list_id'];
        this.inv_model['transport_fee'] = this.invoice_detail['transport_fee'];
        this.inv_model['received_by'] = this.invoice_detail['received_by'];
        this.inv_model['is_paid'] = this.invoice_detail['is_paid'];
        this.inv_model['status'] = this.invoice_detail['status'];
        this.inv_model['cost_center'] = this.invoice_detail['cost_center'];
        this.inv_model['sales_acct'] = this.invoice_detail['sales_acct'];
        this.inv_model['acct_number'] = this.invoice_detail['acct_number'];
        this.inv_model['tax_acct'] = this.invoice_detail['tax_acct'];
        this.inv_model['trans_acct'] = this.invoice_detail['trans_acct'];
        if (this.inv_model['is_paid'] == '1')
          this.data_model['is_paid'] = this.Paid;
        else
          this.data_model['is_paid'] = this.Unpaid;

        this.getInvoiceItems();

        if (this.mode == 'edit')
          this.getRetPaymentMethod();
        //this.getPaymentMethod();
      });
  }

  getRetPaymentMethod() {

    let query = "SELECT `ret_inv_payment_method`.*, `payment_type`.*, 'update' AS 'flag'," +
      " `ret_inv_payment_method`.`ret_inv_payment_method_id` AS `inv_payment_method_id`," +
      " 'ret_inv_payment_method_id' AS 'key' FROM `ret_inv_payment_method`, " +
      "`payment_type` WHERE `ret_inv_payment_method`.`return_invoice_no` = '" + this.no +
      "' AND `ret_inv_payment_method`.`status` = '1' AND `ret_inv_payment_method`.`payment_type_id` = `payment_type`.`payment_type_id`";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp1 = data.data['list'];
        this.dataSource1 = new MatTableDataSource(this.dp1);
        this.dataSource1.sort = this.sort;

        this.dp1.forEach(element => {
          if (element.payment_type_key == 'bank' || element.payment_type_key == 'visa') {
            document.getElementById('tr_bank_acct').style.display = 'table-row';
            document.getElementById('tr_bank_acct2').style.display = 'table-row';

            this.data_model['bank_acct_number'] = element.acct_number;
            let query1 = "SELECT * FROM `bank_account` WHERE `acct_number` = '" + element.acct_number + "'";
            obj = { cmd: 'getList', query: query1 };

            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                let acct_info = data.data['list'][0];
                (document.getElementById('search_value_10000') as HTMLInputElement).value = acct_info.bank_acct_number +
                  ' - ' + acct_info.acct_number + ' - ' + acct_info.account_name + ' - ' + acct_info.account_name_en;
              });
          }

          // ******************* Based on the invoice payment method fill amount, inv_payment_method_id and falg in All Payment Types array ******************* //
          this.all_payment_types.forEach(element1 => {

            if (element1.payment_type_id == element.payment_type_id) {
              element1.amount = element.amount;
              element1.inv_payment_method_id = element.ret_inv_payment_method_id;
            }
            else if (element1.flag == undefined) {
              element1.amount = '';
              element1.inv_payment_method_id = '';
            }
            element1.flag = '';
          });
        });
        console.log(this.all_payment_types);
      });
  }

  // getPaymentMethod() {

  //   /////////////////////////// get invoice payment method ///////////////////////////
  //   let table_name = (this.type == 'invoice' ? 'inv_payment_method' : 'supp_inv_payment_method');
  //   let field_no = this.type + "_no";

  //   let query = "SELECT `" + table_name + "`.*, `payment_type`.* FROM `" + table_name + "`, `payment_type` WHERE `" +
  //     table_name + "`.`" + field_no + "` = '" + this.no + "' AND `" + table_name +
  //     "`.`payment_type_id` = `payment_type`.`payment_type_id`";
  //   let obj = { cmd: 'getList', query: query };
  //   // console.log(query);
  //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
  //     .subscribe(data => {
  //       this.applicationConstants.appComp.hideBusyCursor();
  //       this.inv_payment_method = data.data['list'];
  //       this.dp1 = data.data['list'];

  //       this.dp1.push({
  //         'payment_type_id': '0', 'payment_type_key': 'total', 'payment_type_name': 'المجموع المدخل',
  //         'payment_type_name_en': 'Total', 'amount': this.data_model['final_total_ret']
  //       });
  //       this.dataSource1 = new MatTableDataSource(this.dp1);
  //       this.dataSource1.sort = this.sort;

  //       // this.dp1.forEach(element => {
  //       //   if (element.payment_type_key == 'credit')
  //       //     document.getElementById('tr_payment_date').style.display = 'table-row';
  //       //   else if (element.payment_type_key == 'bank' || element.payment_type_key == 'visa')
  //       //     document.getElementById('tr_bank_acct').style.display = 'table-row';
  //       // });
  //     });
  // }

  getInvoiceItems() {
    this.dp = [];
    // this.count = 0;
    let obj;
    if (this.mode == 'edit')
      obj = {
        cmd: 'getInvoiceItem', type: 'invoice', invoice_no: this.inv_model['invoice_no'],
        for_return: true, ret_invoice_no: this.model['return_invoice_no']
      };
    else
      obj = {
        cmd: 'getInvoiceItem', type: 'invoice', invoice_no: this.inv_model['invoice_no'],
        for_return: true
      };

    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.invoice_item = [];
        if (data.status['type'] == 'success')
          this.invoice_item = data.status['msg'];

        console.log(this.invoice_item);
        this.dp = this.invoice_item;
      });
  }

  // updateDP(element, element_count) {
  //   this.count++;
  //   //console.log(element);
  //   this.dp.push({
  //     'id': this.count, 'available_count': '', 'sub_item_unit': element.sub_item_unit,
  //     'sub_item_primary_qty': element.sub_item_primary_qty, 'sub_item_no': element.sub_item_no, 'invoice_item_id': element.invoice_item_id,
  //     'sub_item_number': element.sub_item_number, 'sub_item_name': element.sub_item_name, 'unit_name': element.unit_name,
  //     'min_price': element.min_price, 'price': element.price, 'price_flex': element.price_flex, 'count': element.count,
  //     'min_sale_qty': element.min_sale_qty, 'total_price': String(Number(element.price) * Number(element.count)),
  //     'discount': element.discount, 'tax_no': element.tax_no, 'tax_amount': element.tax_amount,
  //     'net_price': String((Number(element.price) * Number(element.count)) - Number(element.discount) + Number(element.tax_amount)),
  //     'comment': element.comment
  //   });
  //   if (this.count == element_count)
  //     this.invoice_item = this.dp;
  // }

  changeFinalTotal() {

    if (this.model['total'] != '' && Number(this.model['total']) != 0) {
      let index;
      if (this.dp1.length == 0 || this.dp1.length > 1) {

        if (this.mode == 'edit') {
          let existed = false;

          // ******************* in the edit mode, change the payment method to default and change the flag of saved payment method to delete and remove it from array ******************* //
          for (let indx = this.dp1.length - 1; indx >= 0; indx--) {
            existed = false;

            for (index = 0; index < this.payment_list.length; index++) {
              if (this.payment_list[index]['payment_type_id'] == this.dp1[indx]['payment_type_id']) {
                existed = true;
                break;
              }
            }

            if (!existed) {
              let flag = this.dp1[indx]['flag'];

              if (flag != 'new') {
                for (index = 0; index < this.all_payment_types.length; index++) {
                  if (this.all_payment_types[index]['payment_type_id'] == this.dp1[indx]['payment_type_id']) {
                    this.all_payment_types[index]['amount'] = this.dp1[indx]['amount'];
                    this.all_payment_types[index]['flag'] = 'delete';
                    this.all_payment_types[index]['inv_payment_method_id'] = this.dp1[indx]['inv_payment_method_id'];

                    break;
                  }
                }
                //         this.dp1[index]['flag'] = 'delete';
                //         let inv_payment_method_id = this.dp1[index]['inv_payment_method_id'];
                //         if(inv_payment_method_id != '' && inv_payment_method_id != '0') {
                //           this.dp1[index]['table_name'] = 'inv_payment_method';
                //           this.toDelete.push(this.dp1[index]);
                //         }
              }
              //       else if(flag == 'new')
              //         this.dp1[index]['flag']  = '';

              this.dp1.splice(indx, 1);
            }
          }

          // ******************* in the edit mode, after changing the flag of saved payment method to delete and remove it from array. if array is empty, fill it with default payment ******************* //
          if (this.dp1.length == 0) {
            this.dp1 = this.payment_list;
            this.all_payment_types.forEach(element1 => {

              if (element1.payment_type_id == this.dp1[0]['payment_type_id']) {
                element1.amount = this.data_model['final_total'];
                if (element1.inv_payment_method_id != '')
                  element1.flag = 'update';
                else
                  element1.flag = 'new';

                return false;
              }
            });
          }
        }
        else {
          // ******************* in the new mode and after filling the array with default payment, change the flag to new ******************* //
          this.dp1 = this.payment_list;
          this.all_payment_types.forEach(element1 => {

            if (element1.payment_type_id == this.dp1[0]['payment_type_id']) {
              element1.amount = this.data_model['final_total_ret'];
              element1.flag = 'new';
            }
            else if (element1.flag == undefined) {
              element1.amount = '';
              element1.flag = '';
            }

            element1.inv_payment_method_id = '';
          });
          // this.model['is_paid'] = '1';

          // this.model['is_paid'] = '1';
          // this.model['acct_number'] = this.applicationConstants.user_info.casher_acct_number;
          // //document.getElementById('tr_payment_date').style.display = 'none';
          // document.getElementById('tr_bank_acct').style.display = 'none';
        }
        let credit_existed = false;
        let bank_existed = false;
        if (this.dp1[0]['payment_type_key'] == 'credit')
          credit_existed = true;
        else if (this.dp1[0]['payment_type_key'] == 'bank' || this.dp1[0]['payment_type_key'] == 'visa')
          bank_existed = true;

        this.model['is_paid'] = (credit_existed ? '0' : '1');
        if (!credit_existed && !bank_existed)
          this.model['acct_number'] = this.applicationConstants.user_info.casher_acct_number;
        //document.getElementById('tr_payment_date').style.display = 'none';
        document.getElementById('tr_bank_acct').style.display = (bank_existed ? 'table-row' : 'none');
        document.getElementById('tr_bank_acct2').style.display = (bank_existed ? 'table-row' : 'none');
      }
      this.dp1[0]['amount'] = this.data_model['final_total_ret'];

      // ******************* change the flag to new if there is no id and update if there is  ******************* //
      for (index = 0; index < this.all_payment_types.length; index++) {
        if (this.all_payment_types[index]['payment_type_id'] == this.dp1[0]['payment_type_id']) {
          this.all_payment_types[index]['amount'] = this.dp1[0]['amount'];
          console.log(this.dp1[0]['amount']);
          // this.all_payment_types[index]['flag'] = this.dp1[0]['flag'];

          if (this.all_payment_types[index]['inv_payment_method_id'] != '') {
            this.all_payment_types[index]['flag'] = 'update';
            // if (this.mode == 'edit') {
            //   this.all_payment_types[index]['amount'] = this.data_model['final_total_ret'];
            //   this.all_payment_types[index]['ret_supp_inv_payment_method_id'] = this.dp1[0]['ret_supp_inv_payment_method_id'];
            // }
          }
          else
            this.all_payment_types[index]['flag'] = 'new';

          break;
        }
      }
      // if (this.dp1.length == 1) {
      //   this.dp1.push({
      //     'payment_type_id': '0', 'payment_type_key': 'total', 'payment_type_name': 'المجموع المدخل',
      //     'payment_type_name_en': 'Total', 'amount': this.data_model['final_total_ret']
      //   });
      // }
      // else if (this.dp1.length == 2)
      //   this.dp1[1]['amount'] = this.data_model['final_total_ret'];

    }
    else {
      if (this.mode == 'edit') {
        this.all_payment_types.forEach(element1 => {
          element1.amount = '';
          if (element1.inv_payment_method_id == '') {
            element1.flag = '';
          }
        });
      }
      else {
        this.all_payment_types.forEach(element1 => {
          element1.amount = '';
          element1.flag = '';
          element1.inv_payment_method_id = '';
        });
      }
      this.dp1 = [];
      // this.payment_method = '';
    }
    this.dataSource1 = new MatTableDataSource(this.dp1);
    this.dataSource1.sort = this.sort;
    console.log(this.all_payment_types);
  }

  addPayment() {
    if (this.model['total'] != '' && Number(this.model['total']) != 0) {
      let dialog_data = {
        'total_amount': this.data_model['final_total_ret'], 'payment_methods': this.dp1,
        'all_payment_types': this.all_payment_types
      };
      this.payDialogRef = this.dialog.open(SuppInvPaymentMethodComponent, {
        hasBackdrop: false,
        data: dialog_data
      });
      this.payDialogRef
        .afterClosed()
        .subscribe(result => {
          if (result['payment_methods'] != undefined && Array.isArray(result['payment_methods'])) {
            let credit_existed = false;
            let bank_existed = false;
            //console.log(this.dp1);

            result['payment_methods'].forEach(element => {
              if (element.payment_type_key == 'credit')
                credit_existed = true;
              else if (element.payment_type_key == 'bank' || element.payment_type_key == 'visa')
                bank_existed = true;
            });
            // document.getElementById('tr_payment_date').style.display = (credit_existed ? 'table-row' : 'none');
            document.getElementById('tr_bank_acct').style.display = (bank_existed ? 'table-row' : 'none');
            document.getElementById('tr_bank_acct2').style.display = (bank_existed ? 'table-row' : 'none');
            this.model['is_paid'] = (credit_existed ? '0' : '1');

            this.dp1 = result['payment_methods'];

            this.dataSource1 = new MatTableDataSource(this.dp1);
            this.dataSource1.sort = this.sort;

            if (result['all_payment_types'] != undefined && Array.isArray(result['all_payment_types']))
              this.all_payment_types = result['all_payment_types'];
            // this.total_entered = this.dp1['0']['total_entered'];
          }

        });
    }
    else
      alert(this.One_Item_Msg);
  }

  // onChangeBank = function (search_result: object) {
  onChangeBankAcct = function (acct_number: string) {
    // this.data_model['bank_acct_number'] = search_result['no'];

    this.data_model['bank_acct_number'] = acct_number;
    console.log(this.data_model['bank_acct_number']);
    // ******************* In Edit Mode, change flag for bank or visa payment method to update if there is ******************* //
    if (this.mode == 'edit') {

      this.dp1.forEach(element => {
        if (element.payment_type_key == 'bank' || element.payment_type_key == 'visa') {

          this.all_payment_types.forEach(element1 => {
            if (element1.payment_type_key == element.payment_type_key) {
              if (element1.inv_payment_method_id != '')
                element1.flag = 'update';
              return false;
            }
          });

          return false;
        }
      });
    }
  }

  onChange = function (dpList: any) {
    this.dp = dpList;
    this.changeFinalTotal();
  }

  saveInvoice(save_type) {
    // console.log(this.model['total']);
    let is_cash = false;
    let is_bank = false;
    this.dp1.forEach(element => {
      if (element.payment_type_key == 'cash')
        is_cash = true;
      else
        if (element.payment_type_key == 'bank' || element.payment_type_key == 'visa')
          is_bank = true;
    });
    // if(this.data_model['has_customer'] == '1' && this.model['customer_no'] == '')
    //   alert("الرجاء اختيار العميل في حال اختيار البحث عن العميل");
    // else 
    if (this.model['total'] == '' || Number(this.model['total']) == 0) {
      alert(this.One_Item_Msg);
      return;
    }

    if (this.dp1.length == 0) {
      alert(this.Pay_Msg);
      return;
    }

    if (is_bank && this.data_model['bank_acct_number'] == '0') {
      alert(this.Bank_Acct_Msg);
      return;
    }

    if (is_cash && this.applicationConstants.user_info['is_counter'] == '0') {
      alert(this.Not_Counter_Msg);
      return;
    }

    this.model['return_date'] = (this.data_model['return_date'].getFullYear() + "-" + (this.data_model['return_date'].getMonth() + 1) + "-"
      + this.data_model['return_date'].getDate() + ' ' + (new Date()).getHours() + ':' + (new Date()).getMinutes() +
      ':' + (new Date()).getSeconds());

    let year;
    if (this.mode != 'edit') {
      year = this.data_model['return_date'].getFullYear();
      this.model['year'] = String(year);
    }

    this.model['invoice_no'] = this.inv_model['invoice_no'];

    let is_equal_tax = true;
    let is_equal_ret = true;
    this.dp.forEach(element => {
      if (element.tax_no != this.dp['0']['tax_no'])
        is_equal_tax = false;

      if (element.sale_ret_acct_no != this.dp['0']['sale_ret_acct_no'])
        is_equal_ret = false;
    });

    if (is_equal_tax)
      this.model['tax_acct'] = this.dp['0']['tax_no'];
    if (is_equal_ret)
      this.model['ret_sales_acct'] = this.dp['0']['sale_ret_acct_no'];

    if (this.dp1.length == 1) {
      if (this.dp1[0].payment_type_key == 'credit')
        this.model['acct_number'] = this.inv_model['customer_no'];
      else if (this.dp1[0].payment_type_key == 'cash')
        this.model['acct_number'] = this.applicationConstants.user_info.casher_acct_number;
      else if (this.dp1[0].payment_type_key == 'bank' || this.dp1[0].payment_type_key == 'visa')
        this.model['acct_number'] = this.data_model['bank_acct_number'];

      this.model['payment_method'] = this.dp1[0].payment_type_key;
    }
    else {
      this.model['acct_number'] = '0';
      this.model['payment_method'] = '';
    }
    let invoice_uuid = uuidv4();
    //console.log('Your UUID is: ' + invoice_uuid);
    this.model['invoice_uuid'] = invoice_uuid;

    let values = [];
    values.push(this.model);

    let return_count, comment, damage, damage_reason;

    this.dp.forEach(element => {
      return_count = (document.getElementById('return_count_' + element.id) as HTMLInputElement).value;
      damage = ((document.getElementById('damage_' + element.id) as HTMLInputElement).checked ? '1' : '0');
      damage_reason = (document.getElementById('damage_reason_' + element.id) as HTMLInputElement).value;
      comment = (document.getElementById('comment_' + element.id) as HTMLInputElement).value;

      if ((this.mode != 'edit' && return_count != '' && return_count != '0') || this.mode == 'edit') {

        if (this.mode == 'edit' && (return_count == '' || Number(return_count) == 0))
          element.flag = 'delete';

        // for the items
        values.push({
          'table_name': 'return_invoice_item', 'return_invoice_no': this.model['return_invoice_no'], 'invoice_item_id': element.invoice_item_id,
          'sub_item_number': element.sub_item_number, 'sub_item_name': element.sub_item_name,
          'return_count': return_count, 'price': element.price, 'unit_id': element.unit_id,
          'return_tax': (Number(element.return_tax)).toFixed(2), 'total_price': (Number(element.return_total_price)).toFixed(2),
          'discount': (Number(element.return_discount)).toFixed(2), 'tax_no': element.tax_no, 'damage': damage,
          'damage_reason': damage_reason, 'stock_no': element.stock_no, 'return_date': this.model['return_date'],
          'store_id': element.store_id, 'primary_sub_item_number': element.primary_sub_item_number,
          'flag': element.flag, 'key': 'return_item_id', 'return_item_id': element.return_item_id,
          'primary_quantity': (element.stock_no != '0' ? (Number(return_count) * Number(element.primary_quantity)).toFixed(2) : '0'),
          'comment': comment, 'sale_ret_acct_no': element.sale_ret_acct_no
        });

        if (damage == '1' && element.stock_no != '0' && element.stock_no != '') {

          values.push({
            'table_name': 'stock_damage', 'damage_id': '0', 'stock_no': element.stock_no,
            'store_id': element.store_id, 'sub_item_number': element.primary_sub_item_number,
            'damage_date': this.model['return_date'], 'damage_type': 'damage',
            'key': 'damage_id', 'flag': 'new',
            'quantity': (Number(return_count) * Number(element.primary_quantity)).toFixed(2),
            'reason': damage_reason, 'return_invoice_no': this.model['return_invoice_no'], 'comment': comment
          });
        }
      }
    });

    let acct_number, inv_payment_method_id;

    this.all_payment_types.forEach(element1 => {
      if (element1.flag != '') {
        if (element1.payment_type_key == 'cash')
          acct_number = this.applicationConstants.user_info.casher_acct_number;
        else if (element1.payment_type_key == 'credit')
          acct_number = this.inv_model['customer_no'];
        else if (element1.payment_type_key == 'bank' || element1.payment_type_key == 'visa')
          acct_number = this.data_model['bank_acct_number'];

        inv_payment_method_id = element1.inv_payment_method_id;
        if (inv_payment_method_id == '' || inv_payment_method_id == null || inv_payment_method_id == undefined ||
          inv_payment_method_id == 'undefined')
          inv_payment_method_id = '0';

        // if (this.mode == 'edit')
        //   inv_payment_method_id = element1.ret_inv_payment_method_id;

        if (element1.amount == '')
          element1.amount = '0';

        values.push({
          'table_name': 'ret_inv_payment_method', 'return_invoice_no': this.model['return_invoice_no'],
          'ret_inv_payment_method_id': inv_payment_method_id, 'flag': element1.flag, 'key': 'ret_inv_payment_method_id',
          'payment_type_id': element1.payment_type_id, 'acct_number': acct_number, 'amount': element1.amount
        });
      }
    });

    //return;

    let obj;
    
    if (this.mode == 'edit')
      obj = { cmd: 'updateAdv', values: values };
    else {
      let idWhere = " WHERE `year` = '" + year + "' AND `branch_id` = '" + 
        this.model['branch_id'] + "'";
      let prefix = 'RET-' + this.model['branch_id'] + '-' + year;

      obj = {
        cmd: 'add', values: values, pk: 'return_invoice_no', id: 'no', main_table: 'return_invoice',
        prefix: prefix, idWhere: idWhere
      };
    }
     
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'success') {
          let ret_invoice_no;
          if (this.mode == 'edit')
            ret_invoice_no = this.no;
          else
            ret_invoice_no = data.status['msg'][0]['number'];

          alert(this.Success_Msg + this.Ret_No_Msg + ret_invoice_no); // :  " + invoice_no

          if (save_type == 'print' && this.print_type == 'normal')
            window.open(this.applicationConstants.generatePDF + "?type=return_invoice&no=" + ret_invoice_no, "_blank");

          this.router.navigate(['sub_menu/1/return_invoice_list']);
        }
        else
          alert(this.Error_Msg);
      });

  }

}